export default "__VITE_ASSET__JdVCooR___"